<template lang='pug'>
  blue-layout(:user='user' :account='account' :biz='biz')
    template(v-slot:header)
      bf-header(title='About Us')
    #contact-us.view.with-header
      bf-wrapper.positioned.content
        header
          h1 About BlueFaucet
          h4 BlueFaucet was founded in Oct 2018
        summary
          | BlueFaucet aims to be a P2P platform for a wide variety of services.  After talking to many small business owners and individuals,
          | we found that there are limited resources and services that can help them with connecting with their customers, scheduling appointments
          | and other tasks needed for their businesses.  

        section
          h5 Challenges:
          ol
            li Limited staff to connect to customers and give reminders to return for appointments in regular intervals
            li Limited ability to care for customers
            li Limited budget and means for advertisement
            li High competition in the local market
            li Limited manpower
            li Lack of technological knowledge

          p
            | BlueFaucet provides easy to use features that allow users to manage their service business.  Such features include overseeing
            | appointments, customers, orders, marketing, and more.  Compared to traditional CRM software, BlueFaucet focuses more on ease
            | of usability.  However, this ease of use does not limit its capabilities. Our AI engine is constantly learning to provide
            | information to identify potential customers and better services to existing customers.

        section
          h5 Our Spirit:
          h6 "Together, we serve the world. We want to help build the best experience between merchants and their customers."

        section
          h5 Case Study:
          ol
            li John is an animal lover; he enjoys walking dogs and playing with cats. In his spare time, he uses BlueFaucet to offer dog-walking services and pet watching/hotel services to his neighbors as a side job.
            li Mary has a beauty salon.  Some customers come on a regular basis, but some need to be reminded.  BlueFaucet does the reminding and enables the customer to book the appointment without calling or checking with Mary. Mary can also provide coupons, gift cards and discount memberships for her customers. After each interaction, she and her customers both can record their experiences and everyone can have a better experience.

        section
          h5 Goals & Steps:
          p First, BlueFaucet will target existing small businesses and help them manage their existing customer base by providing online appointment function, management of customer records, marketing, etc.
          p Second, BlueFaucet will appeal to individuals that have time and would like to provide services.  Implementing a ‘Contacts’ function will allow users to officially make appointments and transactions between friends and family.
          p By growing our member base in both directions, BlueFaucet will become an ecosystem that allows for comfortable and efficient exchanges between customers and merchant members.
</template>

<script>
  import { View } from '@/mixins/view'

  export default {
    name: 'about-us.view',

    mixins: [ View ]
  }
</script>

<style scoped lang='stylus'>
  #contact-us.view
    text-align justify
    line-height 1.5

  section, summary, p
    background white
    padding 15px
    margin 12px 0
  section
    margin 48px 0
  h1
    margin-bottom 48px
  h4, h5
    margin-bottom 12px
  h6
    padding 0 48px
    text-align center
    font-style italic

  ol
    list-style circle
    li
      margin-left 18px
</style>
